module.exports = __webpack_public_path__ + "img/fi-rr-settings-sliders.8cd1b9bb.svg";